var FormFlightAttendant = ( function($) {

    var FormFlightAttendant = function(options) {
        var that = this;

        // SELECTORS
        that.class = {
            input_birthday: '.js-input-birthday',
            select_attendant_cert: '.js-toggle-existence-attendant-cert',
            attendant_certificate_wrapper: '.js-attendant-certificate-wrapper',
            input_photo_file: '.js-input-photo-file',
            select_tattoos_existence: '.js-toggle-existence-tattoos',
            tattoos_place_field: '.js-tattoos-place-field',
            input_date: '.js-date',
            input_sex: '.js-input-sex',
            select_education_type: '.js-toggle-education-type',
            education_information: '.js-education-information',
            input_education_information: '.js-input-education-information',
            input_education_begin_date: '.js-input-education-begin-date',
            input_education_finish_date: '.js-input-education-finish-date',
            input_education_qualification: '.js-input-education-qualification',
            add_education_button: '.js-education-add-button',
            remove_education_button: '.js-education-remove-button',
            additional_education_toggle: '.js-toggle-additional-education',
            additional_education_wrapper: '.js-additional-education-information-wrapper',
            additional_education_information: '.js-additional-education-information',
            remove_additional_education_button: '.js-additional-education-remove-button',
            input_additional_education_information: '.js-input-additional-education-information',
            input_additional_education_name: '.js-input-additional-education-name',
            input_additional_education_begin_date: '.js-input-additional-education-begin-date',
            input_additional_education_finish_date: '.js-input-additional-education-finish-date',
            add_additional_education_button: '.js-additional-education-add-button',
            toggle_has_work_experience: '.js-toggle-has-work-experience',
            workplace_information_wrapper: '.js-workplace-information-wrapper',
            workplace_information: '.js-workplace-information',
            remove_workplace_button: '.js-workplace-remove-button',
            input_workplace_company: '.js-input-workplace-company',
            input_workplace_position: '.js-input-workplace-position',
            input_workplace_begin_date: '.js-input-workplace-begin-date',
            input_workplace_finish_date: '.js-input-workplace-finish-date',
            input_workplace_firing_reason: '.js-input-workplace-firing-reason',
            add_workplace_button: '.js-workplace-add-button',
            foreign_language_information: '.js-foreign-language-information',
            remove_foreign_language_button: '.js-foreign-language-remove-button',
            select_foreign_language_name:'.js-toggle-foreign-language-name',
            foreign_language_level:'.js-foreign-language-level',
            add_foreign_language_button: '.js-foreign-language-add-button',
            military_service_wrapper: '.js-military-service-wrapper',
            military_service_attitude: '.js-toggle-military-attitude',
            military_service_document: '.js-toggle-military-service-document',
            military_service_category_wrapper: '.js-military-category-wrapper',
            military_service_category: '.js-toggle-military-category',
            military_service_delay_wrapper: '.js-military-service-delay-wrapper',
            military_service_delay_information: '.js-military-service-delay-information',
            conviction_existence: '.js-toggle-existence-conviction',
            conviction_information_wrapper: '.js-conviction-information-wrapper',
            has_children_toggle: '.js-toggle-has-children',
            children_info_wrapper: '.js-children-info-wrapper'
        };
        
        // DOM
        that.$wrapper = options["$wrapper"];
        
        that.$input_birthday = that.$wrapper.find(that.class.input_birthday);
        
        that.$select_attendant_cert_input = that.$wrapper.find(that.class.select_attendant_cert);
        that.$attendant_certificate_wrapper = that.$wrapper.find(that.class.attendant_certificate_wrapper);
        
        that.$input_photo_file = that.$wrapper.find(that.class.input_photo_file);
        
        that.$select_tattoos_existence = that.$wrapper.find(that.class.select_tattoos_existence);
        that.$tattoos_place_field = that.$wrapper.find(that.class.tattoos_place_field);
        
        that.$additional_education_toggle = that.$wrapper.find(that.class.additional_education_toggle);
        that.$additional_education_wrapper = that.$wrapper.find(that.class.additional_education_wrapper);
        
        that.$education_inforamtion_clone = that.$wrapper.find(that.class.education_information).clone();
        that.$additional_education_information_clone = that.$wrapper.find(that.class.additional_education_information).clone();
        
        that.$toggle_has_work_experience = that.$wrapper.find(that.class.toggle_has_work_experience);
        that.$workplace_information_wrapper = that.$wrapper.find(that.class.workplace_information_wrapper);
        that.$workplace_information_clone = that.$wrapper.find(that.class.workplace_information).clone();
        that.$foreign_language_clone = that.$wrapper.find(that.class.foreign_language_information).clone();
        
        that.$military_service_wrapper = that.$wrapper.find(that.class.military_service_wrapper);
        that.$military_service_attitude = that.$wrapper.find(that.class.military_service_attitude);
        that.$select_military_service_attitude = that.$military_service_attitude.closest('.select');
        that.$military_service_document = that.$wrapper.find(that.class.military_service_document);
        that.$select_military_service_document = that.$military_service_document.closest('.select');
        that.$military_service_category_wrapper = that.$wrapper.find(that.class.military_service_category_wrapper);
        that.$military_service_category = that.$military_service_category_wrapper.find(that.class.military_service_category);
        that.$select_military_service_category = that.$military_service_category.closest('.select');
        that.$military_service_delay_wrapper = that.$wrapper.find(that.class.military_service_delay_wrapper);
        that.$military_service_delay_information = that.$military_service_delay_wrapper.find(that.class.military_service_delay_information);
        
        that.$select_conviction_existence = that.$wrapper.find(that.class.conviction_existence);
        that.$conviction_information_wrapper = that.$wrapper.find(that.class.conviction_information_wrapper);
        
        that.$has_children_toggle = that.$wrapper.find(that.class.has_children_toggle);
        that.$children_info_wrapper = that.$wrapper.find(that.class.children_info_wrapper);
        
        // CONST
        that.photo_allowed_extensions = ['jpg', 'jpeg', 'png', 'webp'];
        that.max_education_blocks = 3;
        that.max_additional_edication_blocks = 3;
        that.max_workplace_blocks = 7;
        that.max_foreign_language_blocks = 3;
        
        // DYNAMIC VARS
        that.locales = options['locales'] || {};

        that.init(options);
    };

    var Self = FormFlightAttendant;
    Self.className = 'FormFlightAttendant';
    var Parent = FormAbstract;

    var def = FormAbstract.def;

    // "inherit"
    Self.prototype = Object.create(Parent.prototype);
    Self.prototype.constructor = Self;

    Self.prototype.init = function (options) {
        var that = this;

        options.onDoneSubmitCallback = function (response) {
            
            that.$wrapper.find('.js-form-flight-attendant').hide();
            that.$wrapper.find('.js-success-result').show();
            $.sa.scrollToNode(that.$wrapper, 200, null);
        }

        options.onAlertSubmitCallback = function (error) {
            var msg = error && error.message ? error.message : that.locales.error_message;
            $.uiModal({
                header_icons: '<div class="align-center"><i class="fab fa-sa-fill-mood-suprised2"></i><i class="fab fa-sa-fill-circle-x"></i></div>',
                header_title: '<div class="align-center">' + that.locales.error_title + '</div>',
                content: '<div class="align-center">' + msg + '</div>',
                button_align_center: true,
                button_confirm_text: that.locales.confirm_text,
            });
        }
        
        Parent.prototype.init.call(that, options);
        
        that.initGroupElements();
        that.initInputMask();
        that.initToggles();
    };

    Self.prototype.initVars = function (options) {
        var that = this;
        options = options || {};

        that.selectors = {
            form: '.js-form-flight-attendant',
        };

        that.method = 'POST';

        that.url = def(options.url, '');
        that.has_success_screen = false;

        Parent.prototype.initVars.call(that, options);
        that.className = Self.className;
    };

    Self.prototype.__initInputHandlers = function () {
        var that = this;
        
        that.$input_birthday.on('blur', function (){
            if (!UIInputMask.prototype.validateBirthday(this.value)) {
                UIInput.prototype.setError(that.$input_birthday);
            }
        });
        
        that.$wrapper.on('blur', that.classes.input_date, function (e) {
            var $that = $(this);
            
            if (!UIInputMask.prototype.validateCorrectDate(this.value)) {
                UIInput.prototype.setError($that);
            }
        });
    };
    
    Self.prototype.initInputMask = function () {
        var that = this;
        
        UIInputMask.prototype.initBirthdayMask(that.$input_birthday);
        UIInputMask.prototype.initDateMask(that.$wrapper);
        UIInputMask.prototype.initPhoneMask(that.$wrapper);
        UIInputMask.prototype.initEmailValidate(that.$wrapper);
        UIInputMask.prototype.initHumanHeightMask(that.$wrapper);
        UIInputMask.prototype.initCountMask(that.$wrapper, 1, 20);

        that.__initInputHandlers();
    };
    
    Self.prototype.__initMilitaryBlock = function () {
        var that = this;

        that.$wrapper.on('click', that.class.input_sex, function (e) {
            var $button = $(e.currentTarget)
                UISelect.prototype.clearValue(that.$select_military_service_attitude);
                that.$military_service_wrapper.hide();
            
            if ($button.val() === 'male') {
                that.$military_service_wrapper.show();
            }

        });
        
        that.$military_service_attitude.on('change', function () {
            UISelect.prototype.clearValue(that.$select_military_service_document);
        });

        that.$military_service_document.on('change', function (e) {
            var $select = $(e.target),
                military_document = $select.val()
                attitude = that.$military_service_attitude.val();
                

            UISelect.prototype.clearValue(that.$select_military_service_category);
            UIInput.prototype.clearInput(that.$military_service_delay_information);
            that.$military_service_category_wrapper.hide();
            that.$military_service_delay_wrapper.hide();
            
            if (attitude === 'paramilitary') {
                if (military_document === 'military_ticket') {
                    that.$military_service_category_wrapper.show();
                } else if (military_document === 'military_certificate') {
                    that.$military_service_category_wrapper.show();
                    that.$military_service_delay_wrapper.show();
                }
            }
        });
    }
    
    Self.prototype.initToggles = function () {
        var that = this;
        
        that.__initHasCertToggle();
        that.__initSimpleToggles()
        that.__initMilitaryBlock();
    }
    
    Self.prototype.__initHasCertToggle = function () {
        var that = this;

        that.$select_attendant_cert_input.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            that.$attendant_certificate_wrapper.hide();
            
            if (selected_type === 'yes' || selected_type === 'in_learning') {
                that.$attendant_certificate_wrapper.show();
            }
        });
    }

    Self.prototype.__initSimpleToggles = function () {
        var that = this,

            toggle = function($toggle_element, selected_type) {
                $toggle_element.hide();

                if (selected_type === 'yes') {
                    $toggle_element.show();
                }
            };
        
        that.$select_tattoos_existence.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            toggle(that.$tattoos_place_field, selected_type);
        });
        
        that.$select_conviction_existence.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            toggle(that.$conviction_information_wrapper, selected_type);
        });
        
        that.$additional_education_toggle.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            toggle(that.$additional_education_wrapper, selected_type);
        });
        
        that.$toggle_has_work_experience.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            toggle(that.$workplace_information_wrapper, selected_type);
        });
        
        that.$has_children_toggle.on('change', function (e) {
            var $select = $(e.target),
                selected_type = $select.val();

            toggle(that.$children_info_wrapper, selected_type);
        });
    }

    Self.prototype.initGroupElements = function () {
        var that = this;
        
        that.__initEducationBlocks();
        that.__initAdditionalEducationBlocks();
        that.__initWorkplaceBlocks();
        that.__initForeignLanguageBlocks();
    }
    
    Self.prototype.__initEducationBlocks = function () {
        var that = this;
        
        that.indexing_education_blocks = function () {
            var $education_blocks = that.$wrapper.find(that.class.education_information)

            $education_blocks.each(function (index) {
                var current_index = index + 1
                var $block = $(this)
                
                $block.find(that.class.select_education_type).attr('name', 'education[' + current_index + '][type]')
                $block.find(that.class.input_education_information).attr('name', 'education[' + current_index + '][information]')
                $block.find(that.class.input_education_begin_date).attr('name', 'education[' + current_index + '][begin_date]')
                $block.find(that.class.input_education_finish_date).attr('name', 'education[' + current_index + '][finish_date]')
                $block.find(that.class.input_education_qualification).attr('name', 'education[' + current_index + '][qualification]')
                
                if (current_index === that.max_education_blocks) {
                    var $button = $block.find(that.class.add_education_button);
                    $button.hide();
                }
            })
        }

        that.initGroupBlocks(
            that.class.education_information,
            that.class.add_education_button,
            that.class.remove_education_button,
            that.$education_inforamtion_clone,
            function () {
                UIInputMask.prototype.initDateMask(that.$wrapper);
                that.indexing_education_blocks();
            }
        )
    }
    
    Self.prototype.__initAdditionalEducationBlocks = function () {
        var that = this;

        that.indexing_additional_education_blocks = function () {
            var $additional_education_blocks = that.$wrapper.find(that.class.additional_education_information)

            $additional_education_blocks.each(function (index) {
                var current_index = index + 1
                var $block = $(this)

                $block.find(that.class.input_additional_education_information).attr(
                    'name', 'additional_education[' + current_index + '][information]'
                );
                $block.find(that.class.input_additional_education_name).attr('name', 'additional_education[' + current_index + '][course_name]');
                $block.find(that.class.input_additional_education_begin_date).attr(
                    'name', 'additional_education[' + current_index + '][begin_date]'
                );
                $block.find(that.class.input_additional_education_finish_date).attr(
                    'name', 'additional_education[' + current_index + '][finish_date]'
                );

                if (current_index === that.max_additional_edication_blocks) {
                    var $button = $block.find(that.class.add_additional_education_button, {autoUnmask: false});
                    $button.hide();
                }
            })
        }

        that.initGroupBlocks(
            that.class.additional_education_information,
            that.class.add_additional_education_button,
            that.class.remove_additional_education_button,
            that.$additional_education_information_clone,
            function () {
                UIInputMask.prototype.initDateMask(that.$wrapper);
                that.indexing_additional_education_blocks();
            }
        )
        
    }
    
    Self.prototype.__initWorkplaceBlocks = function () {
        var that = this;

        that.indexing_workplace_blocks = function () {
            var $workplace_blocks = that.$wrapper.find(that.class.workplace_information)

            $workplace_blocks.each(function (index) {
                var current_index = index + 1
                var $block = $(this)

                $block.find(that.class.input_workplace_company).attr(
                    'name', 'workplace[' + current_index + '][company]'
                );
                $block.find(that.class.input_workplace_position).attr('name', 'workplace[' + current_index + '][position]');
                $block.find(that.class.input_workplace_begin_date).attr(
                    'name', 'workplace[' + current_index + '][begin_date]'
                );
                $block.find(that.class.input_workplace_finish_date).attr(
                    'name', 'workplace[' + current_index + '][finish_date]'
                );
                
                $block.find(that.class.input_workplace_firing_reason).attr(
                    'name', 'workplace[' + current_index + '][firing_reason]'
                );

                if (current_index === that.max_workplace_blocks) {
                    var $button = $block.find(that.class.add_workplace_button);
                    $button.hide();
                }
            })
        }

        that.initGroupBlocks(
            that.class.workplace_information,
            that.class.add_workplace_button,
            that.class.remove_workplace_button,
            that.$workplace_information_clone,
            function () {
                UIInputMask.prototype.initDateMask(that.$wrapper);
                that.indexing_workplace_blocks();
            }
        )
    }
    
    Self.prototype.__initForeignLanguageBlocks = function () {
        var that = this;

        that.indexing_foreign_language_blocks = function () {
            var $foreign_language_blocks = that.$wrapper.find(that.class.foreign_language_information)

            $foreign_language_blocks.each(function (index) {
                var current_index = index + 1
                var $block = $(this)

                $block.find(that.class.select_foreign_language_name).attr(
                    'name', 'foreign_language[' + current_index + '][name]'
                );
                $block.find(that.class.foreign_language_level).attr(
                    'name', 'foreign_language[' + current_index + '][level]'
                );

                if (current_index === that.max_foreign_language_blocks) {
                    var $button = $block.find(that.class.add_foreign_language_button);
                    $button.hide();
                }
            })
        }
        
        that.initGroupBlocks(
            that.class.foreign_language_information,
            that.class.add_foreign_language_button,
            that.class.remove_foreign_language_button,
            that.$foreign_language_clone,
            function () {
                UIInputMask.prototype.initDateMask(that.$wrapper);
                that.indexing_foreign_language_blocks();
            }
        )
    }
    
    return Self;
    
})(jQuery);